import { countries } from '@umahealth/entities'

export const currencies : Record<countries,string> = {
	AR: 'ARS',
	MX: 'MXN',
	VE: 'VED',
	CO: 'COP'
}